
export default class Atividade {
  constructor(id, descricao, grupo, data, local, referencia, responsavel) {
    this.id = id;
    this.descricao = descricao;
    this.grupo = grupo;
    this.data = data;
    this.local = local;
    this.referencia - referencia;
    this.responsavel = responsavel;
  }

  update(atividade) {
    this.id = atividade.id;
    this.descricao = atividade.descricao;
    this.grupo = atividade.grupo;
    this.data = atividade.data;
    this.local = atividade.local;
    this.referencia = atividade.referencia;
    this.responsavel = atividade.responsavel;
    this.cliente = atividade.cliente;
  }
}
